<div class="wrapper--spacing-horizontal page-content">
  <cow-table
    [ReadOnlyMode]="true"
    [selectedMeasurementDate]="selectedDate"
    (measurementDateChange)="selectedDate = $event"
  />
</div>
